import {AuthenticationService, Authentication} from './authentication';
import {useService} from '..';

export function useAuthentication(): Authentication {
  return useService(AuthenticationService);
}
